import { FC, useState } from "react";
import type { ADXSettings } from "../../model";
import styles from "./AcceleratorOscillatorInputsTab.module.css";

type InputKey = "adxSmoothing" | "diLength";
type InputValues = Record<InputKey, string>;

const FIELDS: { key: InputKey; label: string; min: number; max: number }[] = [
  { key: "adxSmoothing", label: "ADX Smoothing", min: 1, max: 100 },
  { key: "diLength", label: "DI Length", min: 1, max: 100 },
];

interface Props {
  settings: ADXSettings;
  onChange: (settings: ADXSettings) => void;
}

export const ADXInputsTab: FC<Props> = ({ settings, onChange }) => {
  const [values, setValues] = useState<InputValues>({
    adxSmoothing: String(settings.adxSmoothing),
    diLength: String(settings.diLength),
  });

  const handleChange = (key: InputKey, value: string) => {
    setValues((prev) => ({ ...prev, [key]: value }));
  };

  const handleBlur = (key: InputKey, max: number) => {
    const parsed = parseInt(values[key], 10);
    const clamped = isNaN(parsed) ? settings[key] : Math.min(Math.max(1, parsed), max);
    setValues((prev) => ({ ...prev, [key]: String(clamped) }));
    onChange({ ...settings, [key]: clamped });
  };

  return (
    <div className={styles.tab}>
      {FIELDS.map(({ key, label, min, max }) => (
        <div key={key} className={styles.row}>
          <span className={styles.label}>{label}</span>
          <input
            type="number"
            className={styles.input}
            min={min}
            max={max}
            value={values[key]}
            onChange={(e) => handleChange(key, e.target.value)}
            onBlur={() => handleBlur(key, max)}
          />
        </div>
      ))}
    </div>
  );
};
